import React from 'react'
import StatCard from './StatCard'
import PropTypes from 'prop-types'
import { useAuth } from '../../molecules/Auth'
import { getCardValues } from '../../../configs/statisticConfig'

const StatCards = ({ results, onShowMore }) => {
  const { user } = useAuth()
  if (!results) return null

  const cardValues = getCardValues(results, user.role)

  return (
    <div className="px-6 py-8 bg-neutral-100 grid gap-6 grid-cols-responsiveCard">
      {cardValues.map(card => (
        <StatCard
          icon={card.icon}
          title={card.title}
          value={card.value}
          indicator={card.indicator}
          onShowMore={onShowMore}
          key={card.indicator}
        />
      ))}
    </div>
  )
}

StatCards.propTypes = {
  results: PropTypes.shape({
    total_users: PropTypes.number,
    total_institutions: PropTypes.number,
    total_forms: PropTypes.number,
    total_answers: PropTypes.number,
    total_attended: PropTypes.number,
    average_days_to_handle: PropTypes.number
  }),
  onShowMore: PropTypes.func.isRequired
}
export default StatCards
